import { kzs as _kzs } from "@kaizenplatform/cse-tools";
import { applyExistingExpScript } from "./module/existing-exp-script";
const kzs = window.kzs;

const expScript = (context: _kzs.precedingJsContext): Promise<void> => {
  kzs.console.log(context);
  const Promise = kzs.Promise;

  return Promise.resolve().then(() => {
    applyExistingExpScript();

    // ① 「口座開設」ボタン
    $(".btn02").attr("data-kz-track-on-click", "40574,40576");

    // ② 「口座開設はこちら」ボタン
    $("#content~.footBtnFixed .footBtn01 a").attr(
      "data-kz-track-on-click",
      "40575,40576"
    );
  });
};

export default expScript;
